/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientTypeFromJSON, ClientTypeToJSON, } from './ClientType';
import { CustomerTypeFromJSON, CustomerTypeToJSON, } from './CustomerType';
/**
 * Check if a given object implements the Lead interface.
 */
export function instanceOfLead(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function LeadFromJSON(json) {
    return LeadFromJSONTyped(json, false);
}
export function LeadFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'phoneMobile': json['phone_mobile'] == null ? undefined : json['phone_mobile'],
        'name': json['name'] == null ? undefined : json['name'],
        'customerType': json['customer_type'] == null ? undefined : CustomerTypeFromJSON(json['customer_type']),
        'clientType': json['client_type'] == null ? undefined : ClientTypeFromJSON(json['client_type']),
    };
}
export function LeadToJSON(json) {
    return LeadToJSONTyped(json, false);
}
export function LeadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'phone': value['phone'],
        'phone_mobile': value['phoneMobile'],
        'name': value['name'],
        'customer_type': CustomerTypeToJSON(value['customerType']),
        'client_type': ClientTypeToJSON(value['clientType']),
    };
}
